module.exports = __webpack_public_path__ + "static/media/plantE.50fa822b.png";